export function getQos(qosId) {
  return { path: `qoses/${qosId}` };
}

export function getQoses(search) {
  return { path: `qoses${search}` };
}
